import { render, staticRenderFns } from "./q9.vue?vue&type=template&id=46d7b4c9&scoped=true"
import script from "./q9.vue?vue&type=script&lang=js"
export * from "./q9.vue?vue&type=script&lang=js"
import style0 from "./q9.vue?vue&type=style&index=0&id=46d7b4c9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46d7b4c9",
  null
  
)

export default component.exports